import type { SignerSteps_viewer_signerSteps as SignerSteps } from "./initiate_signing/signer_steps_query.graphql";

enum Steps {
  DOCUMENT_STEP = "DocumentStep",
  EMAIL_STEP = "EmailStep",
  ESIGN_AUTHENTICATION_STEP = "EsignAuthenticationStep",
  ESIGN_CONSENT_STEP = "EsignConsentStep",
  KBA_STEP = "KbaStep",
  MEETING_STEP = "MeetingStep",
  PHOTO_IDENTIFICATION_STEP = "PhotoIdentificationStep",
}

export const esignRequiringAuthenticationWithPersona = (signerSteps: SignerSteps[]) =>
  signerSteps.some((step) => step.__typename === Steps.ESIGN_AUTHENTICATION_STEP);

export const meetingRequired = (signerSteps: SignerSteps[]) =>
  signerSteps.some((step) => step.__typename === Steps.MEETING_STEP);

export const kbaRequired = (signerSteps: SignerSteps[]) =>
  signerSteps.some((step) => step.__typename === Steps.KBA_STEP);

export const esignConsentRequired = (signerSteps: SignerSteps[]) =>
  signerSteps.some((step) => step.__typename === Steps.ESIGN_CONSENT_STEP);
